export default __webpack_public_path__ + "static/media/sso-icon.ff7a60ff.svg";